'use client';

import { type MouseEventHandler, forwardRef, useCallback, useContext } from 'react';

import { Slot } from '../slot';
import { DatePickerRootContext } from './context/date-picker-root.context';
import type { DatePickerClosePropsInterface } from './types/date-picker-close.types';

/**
 * @since 10.0.0
 */
export const DatePickerClose = forwardRef<HTMLButtonElement, DatePickerClosePropsInterface>(
  (props: DatePickerClosePropsInterface, forwardedRef) => {
    const { children, onClick, ...rest } = props;
    const { datePicker } = useContext(DatePickerRootContext);

    const onClickHandler = useCallback<MouseEventHandler<HTMLButtonElement>>(
      (event) => {
        datePicker.onClickClose(event);
        onClick?.(event);
      },
      [datePicker, onClick],
    );

    return (
      <Slot
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="DatePicker.Close"
        {...rest}
        onClick={onClickHandler}
      >
        {children}
      </Slot>
    );
  },
);

DatePickerClose.displayName = 'DatePicker.Close';
